import React from "react"
import UserInfo from "../ui/UserInfo"
import { User } from "../../ZeefTypes"
import logo from "../../../../../../img/ecosuite_logo.png"

interface ZeefChatHeaderProps {
  currentUser: User | null
  isLoadingUser: boolean
  isConnected: boolean
  isEditingUsername: boolean
  editingUsername: string
  onUsernameClick: () => void
  onUsernameChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onUsernameKeyPress: (event: React.KeyboardEvent<HTMLInputElement>) => void
  onSaveUsername: () => void
  onCancelUsername: () => void
  isUpdatingUsername: boolean
}

const ZeefChatHeader: React.FC<ZeefChatHeaderProps> = ({
  currentUser,
  isLoadingUser,
  isConnected,
  isEditingUsername,
  editingUsername,
  onUsernameClick,
  onUsernameChange,
  onUsernameKeyPress,
  onSaveUsername,
  onCancelUsername,
  isUpdatingUsername,
}) => {
  return (
    <div className="messages-header">
      <div className="header-title">
        <img src={logo} alt="Ecosuite" className="header-logo" />
        <span>ZEEF Chat</span>
      </div>
      <UserInfo
        user={currentUser}
        isLoading={isLoadingUser}
        isConnected={isConnected}
        isEditing={isEditingUsername}
        editingUsername={editingUsername}
        onUsernameClick={onUsernameClick}
        onUsernameChange={onUsernameChange}
        onUsernameKeyPress={onUsernameKeyPress}
        onSaveUsername={onSaveUsername}
        onCancelUsername={onCancelUsername}
        isUpdating={isUpdatingUsername}
      />
    </div>
  )
}

export default ZeefChatHeader
